import { useMutation } from "react-query";
import { Plan } from "../models";
import { deletePlan } from "../mutations/plans/deletePlan";
import { useConfig } from "../utils/useConfig";
import { useData } from "../utils/useData";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { toast } from "react-toastify";

export const useDeletePlan = (options?: {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
  successMessage?: string;
}) => {
  const { config } = useConfig();
  const { employerId, plans, employees, accounts } = useData();
  const { getToken } = useKindeAuth();

  return useMutation(
    async (plan: Plan) =>
      await deletePlan(
        config,
        employerId as string,
        await getToken(),
        plan
      ),
    {
      onSuccess: () => {
        toast.success(options?.successMessage ?? "Plan deleted successfully");
        plans.refetch();
        employees.refetch();
        accounts.refetch();
        options?.onSuccess?.();
      },
      onError: (error: Error) => {
        toast.error(error.message);
        console.error(error.message);
        options?.onError?.(error);
      }
    }
  );
}; 